import React from "react";
import { makeStyles } from '@material-ui/core/styles';

import { ProjectModel } from "../../../../models/projects/project_model.js.jsx";
import PercentFormatter from "../../../../utils/percent_formatter.js.jsx";

const blockStyles = makeStyles(theme => ({
  row: {
    padding: "20px 32px",
    display: "flex",
    fontSize: "16px",
    alignItems: "center",
    "& + &": {
      borderTop: `1px solid ${theme.palette.grayDivider}`
    },
    "&:last-child": {
      borderBottom: `1px solid ${theme.palette.grayDivider}`
    },
    ['@media (max-width: 768px)']: {
      fontSize: "13px",
      padding: "14px 18px",
    },
  },
  column: {
    flex: "0 1 50%",
    padding: "6px 0",
    textAlign: "center",
    "& + &": {
      borderLeft: `1px solid ${theme.palette.grayText}`
    },
    ['@media (max-width: 768px)']: {
      padding: "0px 0",
    },
  },
  largeLabel: {
    flex: "0 1 40%",
    fontSize: "18px",
    fontWeight: 500,
    textAlign: "left",
    paddingRight: "5px",
    textTransform: "capitalize",
    ['@media (max-width: 768px)']: {
      fontSize: "12px"
    }
  },
}));

const BonusRatesBlock = (props) => {
  const classes = blockStyles();
  const { className, project = {} } = props;
  const { bonusRates } = project;
  if(bonusRates.length === 0) {
    return <React.Fragment />
  }
  return (
    <div className = { className } >
      <div className = { classes.row } >
        <h4 className = { classes.largeLabel } > { ProjectModel.fieldDisplayName("bonus_rates") }</h4>
      </div>
      <div className= { classes.row }>
            <div className = { classes.column } >
            { I18n.t("model.projects.bonus_rate.fields.rate") }
            </div>
            <div className = { classes.column } >
            { I18n.t("model.projects.bonus_rate.fields.deadline") }
            </div>
          </div>
      {
        bonusRates.map(bonus_rate => (
          <div className= { classes.row }>
            <div className = { classes.column } >
              { PercentFormatter.format(bonus_rate.rate / 100, "0.00 %") }
            </div>
            <div className = { classes.column } >
              { bonus_rate.deadline }
            </div>
          </div>
        ))
      }
    </div>
  );
}

export default BonusRatesBlock;